var exports = {
  "k": "xfd349460--075fea--container",
};

module.exports = exports;
